module.exports = __webpack_public_path__ + "static/media/GPG179A_H59_SG.ae615ba9.jpg";